module.exports = __webpack_public_path__ + "media/Audio17_m.622c8a27.wav";